import React, { ChangeEvent, memo } from 'react'
import {
  IUseFacilityParamsState,
  IFacilityFilters,
} from 'apps/fleet-planner/hooks/useFacilityParams'
import { TextInput, TextInputIconType } from 'components/atoms'
import { debounce } from 'utils/debounce'

interface IFacilitiesFiltersProps {
  params: IUseFacilityParamsState
  onFilterChange: (filters: IFacilityFilters) => void
}

export const FacilitiesFilters = memo<IFacilitiesFiltersProps>(({ onFilterChange, params }) => {
  const debounceOnFilterChange = debounce(onFilterChange, 500)

  const searchFilterChangeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    debounceOnFilterChange({ nameAddressOrContact: value })
  }
  return (
    <div className='flex flex-row items-center'>
      <div className='col-xs-12 col-md-4 col-lg-3 pl4'>
        <TextInput
          large
          icon={TextInputIconType.search}
          placeholder='Search by address or contact'
          onChange={searchFilterChangeHandler}
          value={params?.filters?.nameAddressOrContact}
          dataTest='facilities-search'
          aria-label='search-facilities-page'
        />
      </div>
    </div>
  )
})
